import axios from "../axios";

const getFeesChildPartner = async function (accessToken,userId) {
    try {
        const response = await axios.get('child-partner/getFeesChildPartner', {
            headers: {
                'Authorization': accessToken
            },
            params: {
                user_id: userId
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getFeesChildPartner;
